module.exports = __webpack_public_path__ + "static/img/qrcode.4e2bbe59.jpg";